import React, { useState, useContext, useEffect } from "react";
import { IconButton, Typography, useMediaQuery } from "@material-ui/core";
import AuthContext from "../../hooks/authContext";
import styles from "./header.module.scss";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import csmWhiteNewText from "../../assets/images/csmWhiteNewText.png";
import { useLocation } from "react-router-dom";
import { useTour } from "../ui/TourContext";

const Header = (props) => {
  const auth = useContext(AuthContext);
  const isMobile = useMediaQuery('(max-width:767px)');  
  const [sRedirect, setRedirect] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { stopTour } = useTour();

  useEffect(() => {
    if (auth.status !== true) {
      setRedirect(true);
    }
  }, [auth.status]);

  const handleClick = () => {
    setIsOpen(false);
    navigate("/account/profile")
  }

  return auth?.status === true ? (
    <div className={`${styles.headerWrap} dark:bg-[#1A1F2C]`}>
      {isMobile ? (
        <>
          {sRedirect === true && <Navigate to="/login" />}
          <div className={`d-flex pv-15 flex-center`}>
            <Link className={styles.logowrap}>
              <Typography component="h6" variant="h6" className={"pr-2"}>
                <img src={csmWhiteNewText} alt="PROTeam Admin Logo" className="cms-logo" />
              </Typography>
            </Link>
          </div>
        </>
      ) : (
        <>
          {sRedirect === true && <Navigate to="/login" />}
          <div className="d-flex flex-center">
              {!props?.change && (
                <Link to="/" onClick={() => {auth.setIsExpanded(false); stopTour();}} className={styles.logowrap}>
                  <Typography component="h6" variant="h6" className={"pr-2"}>
                    <img src={csmWhiteNewText} alt="PROTeam Admin Logo" className="cms-logo" />
                  </Typography>
                </Link>
              )}
            </div>
            {!props?.change && (
              <IconButton onClick={() => props?.setChange(!props?.change)} className="p-0">
                <ChevronLeft style={{color:"white"}} />
            </IconButton>
            )}
            {props?.change && (
            <IconButton onClick={() => props?.setChange(!props?.change)} className="p-0">
                <ChevronRight style={{color:"white"}} />
            </IconButton>
            )}
            {/* {location.pathname !== "/newDashboard" && (
              <>
                <div className={`${styles.headerRight} headerRight user-dropdown`} style={{ width: "auto" }}>
                  <ul className={`menulist usersWrap`}>
                    <li className="userInfo">
                      <div onClick={() => setIsOpen(!isOpen)} className="d-flex flex-center">
                        <Typography className="name">
                          {`${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName} (${auth?.userProfile?.role})`}
                        </Typography>
                        <KeyboardArrowDownIcon fontSize="large" className="color-white" />
                      </div>
                    </li>
                  </ul>
                  {isOpen && (
                    <div className="dropdown-menu">
                      <div className="d-flex flex-center last-login">
                        <AccessTimeIcon fontSize="small" className={`${styles.icons} mh-6`} />
                        <div>
                          <div className="last-login-label">
                            Last login:
                          </div>
                          <div className="last-login-time">{moment(auth?.userProfile?.lastLogin).format("MMMM D, YYYY h:mm:ss")}</div>
                        </div>
                      </div>
                      <div onClick={handleClick} className="dropdown-item">
                        <PersonIcon fontSize="small" className={`${styles.icons} mh-6`} /> Profile
                      </div>
                    </div>
                  )}
                </div>
              </>
            )} */}
      </>
    )}
    </div>
  ) : (
    <></>
  );
};

export default Header;